import { Card, Col, Row } from 'antd';
import React from 'react';
import Chart from 'react-apexcharts';
import bgCard from '../../assets/bg-card-home.png';
import chart1 from '../../assets/gragh1.png';
import chart2 from '../../assets/gragh2.png';
import chart3 from '../../assets/gragh3.png';
import chart4 from '../../assets/gragh4.png';
import { getDashboard } from '../../network/dashboard';
import { queryKeys } from '../../services/react-query/queryKeys';
import { useQuery } from '@tanstack/react-query';
const DashboardCards = ({ t }) => {
  const { data: dashboardData, isLoading } = useQuery({
    queryKey: [queryKeys.getDashboard],
    queryFn: () => getDashboard(),
  });
  console.log(dashboardData, 'dashboardData');

  const data = [
    {
      id: 1,
      title: t.salesInvoice,
      count: dashboardData?.message?.main_header?.[0]?.current_month_total,
      colorTitle: '#FFFFFF',
      label: t.invoice,
      colorLabel: '#FFFFFFCC',
      color: '#FFFFFF',
      bg: 'linear-gradient(138.91deg, rgba(3, 68, 220, 0.64) 5.42%, rgba(64, 122, 255, 0.64) 72.94%)',
      boxShadow: '-8px 8px 8px 0px #4361EE14',
      chart: chart1,
      boxShadowTwo:
        'linear-gradient(180deg, rgba(255, 255, 255, 0.48) 0%, rgba(255, 255, 255, 0) 100%)',
    },
    {
      id: 2,
      title: t.purchaseInvoice,
      colorTitle: '#374151',
      chart: chart2,
      count: dashboardData?.message?.main_header?.[1]?.current_month_total,
      label: t.invoice,
      colorLabel: '#6B7280CC',
      color: '#F04438',
      bg: '#FFFFFFA3',
      boxShadow: '',
      boxShadowTwo:
        'linear-gradient(180deg, rgba(240, 68, 56, 0.48) 0%, rgba(240, 68, 56, 0) 100%)',
    },
    {
      id: 3,
      chart: chart3,
      title: t.ReceiptVoucher,
      colorTitle: '#374151',
      colorLabel: '#6B7280CC',
      count: dashboardData?.message?.main_header?.[2]?.current_month_total,
      label: t.voucher,
      color: '#12B76A',
      bg: '#FFFFFFA3',
      boxShadow: '',
      boxShadowTwo:
        'linear-gradient(180deg, rgba(18, 183, 106, 0.48) 0%, rgba(18, 183, 106, 0) 100%)',
    },
    {
      id: 4,
      title: t.PaymentVoucher,
      chart: chart4,
      colorTitle: '#374151',
      colorLabel: '#6B7280CC',
      count: dashboardData?.message?.main_header?.[3]?.current_month_total,
      label: t.voucher,
      color: '#F79009',
      bg: '#FFFFFFA3',
      boxShadow: '',
      boxShadowTwo:
        'linear-gradient(180deg, rgba(247, 144, 9, 0.48) 0%, rgba(247, 144, 9, 0) 100%)',
    },
  ];
  const series = [
    {
      name: 'data',
      data: [110, 241, 135, 51, 49, 162, 369, 91, 148],
    },
  ];
  const getChartOptions = (item) => ({
    chart: {
      type: 'area',
      height: 70,
      sparkline: {
        enabled: true,
      },
      toolbar: {
        show: false,
      },
    },
    tooltip: {
      enabled: true,
    },
    colors: [item.color],
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical',
        shadeIntensity: 1,
        opacityFrom: 0.8,
        opacityTo: 0.2,
        stops: [0, 100],
        colorStops: [
          {
            offset: 0,
            color: `${item.color}80`,
            opacity: 0.8,
          },
          {
            offset: 100,
            color: `${item.color}00`,
            opacity: 0.2,
          },
        ],
      },
    },
    stroke: {
      width: 3,
      curve: 'smooth',
      colors: [item.color],
    },
    // tooltip: {
    //   enabled: false,
    // },
    dataLabels: {
      enabled: false,
    },

    xaxis: {
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      show: false,
      min: 0,
    },
    grid: {
      show: false,
    },
  });
  return (
    <div className="">
      <Row gutter={[16, 20]}>
        {isLoading
          ? [...Array(4)].map((_, index) => (
              <Col xs={24} sm={24} md={12} lg={12} xl={6} key={index}>
                <Card
                  // bordered={false}
                  variant="borderless"
                  style={{
                    overflow: 'hidden',
                  }}
                  styles={{
                    body: {
                      padding: '24px',
                      overflow: 'hidden',
                    },
                  }}
                  loading
                />
              </Col>
            ))
          : data?.map((item) => (
              <Col xs={24} sm={24} md={12} lg={12} xl={6} key={item?.id}>
                <Card
                  // bordered={false}
                  variant="borderless"
                  style={{
                    background: item?.bg,
                    overflow: 'hidden',
                  }}
                  styles={{
                    body: {
                      padding: '24px',
                      overflow: 'hidden',
                    },
                  }}
                >
                  {item?.id === 1 ? (
                    <img
                      src={bgCard}
                      alt="bg-card"
                      className="absolute -top-5 left-12 w-full h-full object-cover"
                    />
                  ) : (
                    ''
                  )}
                  <h2
                    className={`text-[18px] font-[700]  font-Comfortaa leading-6`}
                    style={{
                      color: item?.colorTitle,
                    }}
                  >
                    {item?.title}
                  </h2>
                  <div
                    className="flex gap-0.5 justify-between items-center mt-[26px]"
                    style={{
                      //   background: item.bg,
                      boxShadow: item?.boxShadow,
                      borderRadius: '10px',
                      //   padding: '20px',
                    }}
                  >
                    <div className="flex gap-1 items-center justify-center">
                      {/* <span
                        className="text-[20px] font-bold"
                        style={{
                          fontFamily:
                            "'Tajawal', 'Almarai', 'Segoe UI', 'sans-serif'",
                          color: item?.color,
                        }}
                      >
                        {item?.count}{' '}
                        <span style={{ fontSize: '18px' }}>﷼</span>
                      </span> */}
                      <span
                        className="text-[24px] font-[700] font-Comfortaa "
                        style={{
                          color: item?.color,
                        }}
                      >
                        {' '}
                        {item?.count}
                      </span>
                      <span
                        className="text-[16px] font-[600] font-sans leading-6"
                        style={{
                          color: item?.colorLabel,
                          fontFamily: "'Tajawal', 'Segoe UI', 'Arial'",
                        }}
                      >
                        ﷼
                      </span>
                      {/* <p
                        className="text-[14px] font-[500] font-Comfortaa leading-6"
                        style={{
                          color: item?.colorLabel,
                        }}
                      >
                        {item?.label}
                      </p> */}
                    </div>
                    {/* <img
                  src={item?.chart}
                  alt="chart"
                
                /> */}
                    <div
                      className=""
                      style={{
                        background: item?.boxShadowTwo,
                        borderRadius: '10px',
                        // padding: '20px',
                      }}
                    >
                      <Chart
                        options={getChartOptions(item)}
                        series={[
                          {
                            name: 'data',
                            data: series[0].data,
                            color: item.color,
                          },
                        ]}
                        type="area"
                        height={70}
                        width={120}
                      />
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
      </Row>
    </div>
  );
};

export default DashboardCards;

// import { Card, Col, Row } from 'antd';
// import React from 'react';
// import Chart from 'react-apexcharts';
// import bgCard from '../../assets/bg-card-home.png';
// import chart1 from '../../assets/gragh1.png';
// import chart2 from '../../assets/gragh2.png';
// import chart3 from '../../assets/gragh3.png';
// import chart4 from '../../assets/gragh4.png';
// import { getDashboard } from '../../network/dashboard';
// import { queryKeys } from '../../services/react-query/queryKeys';
// import { useQuery } from '@tanstack/react-query';
// const DashboardCards = ({ t }) => {
//   const { data: dashboardData, isLoading } = useQuery({
//     queryKey: [queryKeys.getDashboard],
//     queryFn: () => getDashboard(),
//   });
//   console.log(dashboardData, 'dashboardData');

//   // const dataCards = dashboardData?.message?.main_header;
//   // const dataCards = [];
//   const data = [
//     {
//       id: 1,
//       title: t.salesInvoice,
//       count: dashboardData?.message?.main_header?.[0]?.current_month_total,
//       colorTitle: '#FFFFFF',

//       label: t.invoice,
//       colorLabel: '#FFFFFFCC',
//       color: '#FFFFFF',
//       bg: 'linear-gradient(138.91deg, rgba(3, 68, 220, 0.64) 5.42%, rgba(64, 122, 255, 0.64) 72.94%)',
//       boxShadow: '-8px 8px 8px 0px #4361EE14',
//       chart: chart1,
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(255, 255, 255, 0.48) 0%, rgba(255, 255, 255, 0) 100%)',
//     },
//     {
//       id: 2,
//       title: t.purchaseInvoice,
//       colorTitle: '#374151',
//       chart: chart2,
//       count: dashboardData?.message?.main_header?.[1]?.current_month_total,
//       label: t.invoice,
//       colorLabel: '#6B7280CC',
//       color: '#F04438',
//       bg: '#FFFFFFA3',
//       boxShadow: '',
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(240, 68, 56, 0.48) 0%, rgba(240, 68, 56, 0) 100%)',
//     },
//     {
//       id: 3,
//       chart: chart3,
//       title: t.ReceiptVoucher,
//       colorTitle: '#374151',
//       colorLabel: '#6B7280CC',
//       count: dashboardData?.message?.main_header?.[2]?.current_month_total,
//       label: t.voucher,
//       color: '#12B76A',
//       bg: '#FFFFFFA3',
//       boxShadow: '',
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(18, 183, 106, 0.48) 0%, rgba(18, 183, 106, 0) 100%)',
//     },
//     {
//       id: 4,
//       title: t.PaymentVoucher,
//       chart: chart4,
//       colorTitle: '#374151',
//       colorLabel: '#6B7280CC',
//       count: dashboardData?.message?.main_header?.[3]?.current_month_total,
//       label: t.voucher,
//       color: '#F79009',
//       bg: '#FFFFFFA3',
//       boxShadow: '',
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(247, 144, 9, 0.48) 0%, rgba(247, 144, 9, 0) 100%)',
//     },
//   ];
//   const series = [
//     {
//       name: 'data',
//       data: [110, 241, 135, 51, 49, 162, 369, 91, 148],
//     },
//   ];
//   const getChartOptions = (item) => ({
//     chart: {
//       type: 'area',
//       height: 70,
//       sparkline: {
//         enabled: true,
//       },
//       toolbar: {
//         show: false,
//       },
//     },
//     tooltip: {
//       enabled: true,
//     },
//     colors: [item.color],
//     fill: {
//       type: 'gradient',
//       gradient: {
//         type: 'vertical',
//         shadeIntensity: 1,
//         opacityFrom: 0.8,
//         opacityTo: 0.2,
//         stops: [0, 100],
//         colorStops: [
//           {
//             offset: 0,
//             color: `${item.color}80`,
//             opacity: 0.8,
//           },
//           {
//             offset: 100,
//             color: `${item.color}00`,
//             opacity: 0.2,
//           },
//         ],
//       },
//     },
//     stroke: {
//       width: 3,
//       curve: 'smooth',
//       colors: [item.color],
//     },
//     // tooltip: {
//     //   enabled: false,
//     // },
//     dataLabels: {
//       enabled: false,
//     },

//     xaxis: {
//       labels: {
//         show: false,
//       },
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//     },
//     yaxis: {
//       show: false,
//       min: 0,
//     },
//     grid: {
//       show: false,
//     },
//   });
//   return (
//     <div className="">
//       <Row gutter={[16, 20]}>
//         {isLoading
//           ? [...Array(4)].map((_, index) => (
//               <Col xs={24} sm={24} md={12} lg={12} xl={6} key={index}>
//                 <Card
//                   // bordered={false}
//                   variant="borderless"
//                   style={{
//                     overflow: 'hidden',
//                   }}
//                   styles={{
//                     body: {
//                       padding: '24px',
//                       overflow: 'hidden',
//                     },
//                   }}
//                   loading
//                 />
//               </Col>
//             ))
//           : data?.map((item) => (
//               <Col xs={24} sm={24} md={12} lg={12} xl={6} key={item?.id}>
//                 <Card
//                   // bordered={false}
//                   variant="borderless"
//                   style={{
//                     background: item?.bg,
//                     overflow: 'hidden',
//                   }}
//                   styles={{
//                     body: {
//                       padding: '24px',
//                       overflow: 'hidden',
//                     },
//                   }}
//                 >
//                   {item?.id === 1 ? (
//                     <img
//                       src={bgCard}
//                       alt="bg-card"
//                       className="absolute -top-5 left-12 w-full h-full object-cover"
//                     />
//                   ) : (
//                     ''
//                   )}
//                   <h2
//                     className={`text-[18px] font-[700]  font-Comfortaa leading-6`}
//                     style={{
//                       color: item?.colorTitle,
//                     }}
//                   >
//                     {item?.title}
//                   </h2>
//                   <div
//                     className="flex gap-0.5 justify-between items-center mt-[26px]"
//                     style={{
//                       //   background: item.bg,
//                       boxShadow: item?.boxShadow,
//                       borderRadius: '10px',
//                       //   padding: '20px',
//                     }}
//                   >
//                     <div className="flex gap-1 items-center justify-center flex-col">
//                       {/* <span
//                         className="text-[24px] font-[700] font-Comfortaa "
//                         style={{
//                           color: item?.color,
//                         }}
//                       >
//                         {' '}
//                         {item?.count}
//                       </span>
//                       <span
//                         className="text-[16px] font-[600] font-sans leading-6"
//                         style={{
//                           color: item?.colorLabel,
//                           fontFamily: "'Tajawal', 'Segoe UI', 'Arial'",
//                         }}
//                       >
//                         ﷼
//                       </span> */}
//                       <div className="flex items-center gap-1">
//                         <span
//                           className="text-[14px] font-[600]"
//                           style={{ color: '#F97316' }}
//                         >
//                           Total:
//                         </span>
//                         <span
//                           className="text-[14px] font-[600]"
//                           style={{ color: '#F97316' }}
//                         >
//                           {dashboardData?.message?.sales_invoice_header?.[0]
//                             ?.total_taxes_and_charges ?? 0}
//                         </span>
//                         <span
//                           className="text-[14px] font-[600]"
//                           style={{ color: '#F97316' }}
//                         >
//                           ﷼
//                         </span>
//                       </div>
//                       <div className="flex items-center gap-1">
//                         <span
//                           className="text-[14px] font-[600]"
//                           style={{ color: '#F97316' }}
//                         >
//                           Taxes:
//                         </span>
//                         <span
//                           className="text-[14px] font-[600]"
//                           style={{ color: '#F97316' }}
//                         >
//                           {dashboardData?.message?.sales_invoice_header?.[0]
//                             ?.total_taxes_and_charges ?? 0}
//                         </span>
//                         <span
//                           className="text-[14px] font-[600]"
//                           style={{ color: '#F97316' }}
//                         >
//                           ﷼
//                         </span>
//                       </div>
//                     </div>

//                     <div
//                       className=""
//                       style={{
//                         background: item?.boxShadowTwo,
//                         borderRadius: '10px',
//                         // padding: '20px',
//                       }}
//                     >
//                       <Chart
//                         options={getChartOptions(item)}
//                         series={[
//                           {
//                             name: 'data',
//                             data: series[0].data,
//                             color: item.color,
//                           },
//                         ]}
//                         type="area"
//                         height={70}
//                         width={120}
//                       />
//                     </div>
//                   </div>
//                 </Card>
//               </Col>
//             ))}
//       </Row>
//     </div>
//   );
// };

// export default DashboardCards;

// import { Card, Col, Row } from 'antd';
// import React from 'react';
// import Chart from 'react-apexcharts';
// import bgCard from '../../assets/images/bg-card-home.png';
// import chart1 from '../../assets/images/gragh1.png';
// import chart2 from '../../assets/images/gragh2.png';
// import chart3 from '../../assets/images/gragh3.png';
// import chart4 from '../../assets/images/gragh4.png';
// const DashboardCards = () => {
//   const data = [
//     {
//       id: 1,
//       title: 'اجمالي الطلبات الجديدة',
//       count: 64,
//       colorTitle: '#FFFFFF',
//       label: 'مدرسة',
//       colorLabel: '#FFFFFFCC',
//       color: '#FFFFFF',
//       bg: 'linear-gradient(138.91deg, rgba(3, 68, 220, 0.64) 5.42%, rgba(64, 122, 255, 0.64) 72.94%)',
//       boxShadow: '-8px 8px 8px 0px #4361EE14',
//       chart: chart1,
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(255, 255, 255, 0.48) 0%, rgba(255, 255, 255, 0) 100%)',
//     },
//     {
//       id: 2,
//       title: 'اجمالي الطلاب',
//       colorTitle: '#374151',
//       chart: chart2,
//       count: 2563,
//       label: 'طالب',
//       colorLabel: '#6B7280CC',
//       color: '#F04438',
//       bg: '#FFFFFFA3',
//       boxShadow: '',
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(240, 68, 56, 0.48) 0%, rgba(240, 68, 56, 0) 100%)',
//     },
//     {
//       id: 3,
//       chart: chart3,
//       title: 'اجمالي الفروع',
//       colorTitle: '#374151',
//       colorLabel: '#6B7280CC',
//       count: 192,
//       label: 'فرع',
//       color: '#12B76A',
//       bg: '#FFFFFFA3',
//       boxShadow: '',
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(18, 183, 106, 0.48) 0%, rgba(18, 183, 106, 0) 100%);',
//     },
//     {
//       id: 4,
//       title: 'اجمالي المشرفين',
//       chart: chart4,
//       colorTitle: '#374151',
//       colorLabel: '#6B7280CC',
//       count: 87,
//       label: 'طالب',
//       color: '#F79009',
//       bg: '#FFFFFFA3',
//       boxShadow: '',
//       boxShadowTwo:
//         'linear-gradient(180deg, rgba(247, 144, 9, 0.48) 0%, rgba(247, 144, 9, 0) 100%)',
//     },
//   ];
//   const series = [
//     {
//       name: 'data',
//       data: [110, 241, 135, 51, 49, 162, 369, 91, 148],
//     },
//   ];
//   //   const options = {
//   //     chart: {
//   //       type: 'area',
//   //       height: 70,
//   //       sparkline: {
//   //         enabled: true,
//   //       },
//   //       zoom: {
//   //         enabled: false,
//   //       },
//   //     },
//   //     dataLabels: {
//   //       enabled: false,
//   //     },
//   //     stroke: {
//   //       curve: 'straight',
//   //     },
//   //     labels: false,
//   //     x: {
//   //       show: false,
//   //     },
//   //     y: {
//   //       show: false,
//   //     },
//   //     yaxis: false,
//   //     legend: {
//   //       horizontalAlign: 'left',
//   //     },
//   //   };
//   const options = {
//     chart: {
//       type: 'area',
//       height: 70,
//       sparkline: {
//         enabled: true,
//       },
//       toolbar: {
//         show: false,
//       },
//     },
//     colors: ['#FFFFFF'], // لون الخط الرئيسي (تعدله حسب كل كارت)
//     fill: {
//       type: 'gradient',
//       gradient: {
//         shadeIntensity: 1,
//         opacityFrom: 0.7,
//         opacityTo: 0.3,
//         stops: [0, 100],
//       },
//     },
//     stroke: {
//       width: 2,
//       curve: 'smooth',
//     },
//     tooltip: {
//       enabled: false,
//     },
//     dataLabels: {
//       enabled: false,
//     },
//     xaxis: {
//       labels: {
//         show: false,
//       },
//       axisBorder: {
//         show: false,
//       },
//       axisTicks: {
//         show: false,
//       },
//     },
//     yaxis: {
//       show: false,
//     },
//     grid: {
//       show: false,
//     },
//   };
//   return (
//     <div className="">
//       <Row gutter={[16, 20]}>
//         {data?.map((item) => (
//           <Col xs={24} sm={24} md={12} lg={12} xl={6} key={item?.id}>
//             <Card
//               bordered={false}
//               style={{
//                 background: item?.bg,
//                 overflow: 'hidden',
//               }}
//               styles={{
//                 body: {
//                   padding: '24px',
//                   overflow: 'hidden',
//                 },
//               }}
//             >
//               {item?.id === 1 ? (
//                 <img
//                   src={bgCard}
//                   alt="bg-card"
//                   className="absolute -top-5 left-12 w-full h-full object-cover"
//                 />
//               ) : (
//                 ''
//               )}
//               <h2
//                 className={`text-[18px] font-[700]  font-Comfortaa leading-6`}
//                 style={{
//                   color: item?.colorTitle,
//                 }}
//               >
//                 {item?.title}
//               </h2>
//               <div
//                 className="flex gap-0.5 justify-between items-center mt-[26px]"
//                 style={{
//                   //   background: item.bg,
//                   boxShadow: item?.boxShadow,
//                   borderRadius: '10px',
//                   //   padding: '20px',
//                 }}
//               >
//                 <div className="flex gap-1 items-center justify-center">
//                   <span
//                     className="text-[24px] font-[700] font-Comfortaa "
//                     style={{
//                       color: item?.color,
//                     }}
//                   >
//                     {' '}
//                     {item?.count}
//                   </span>
//                   <p
//                     className="text-[14px] font-[500] font-Comfortaa leading-6"
//                     style={{
//                       color: item?.colorLabel,
//                     }}
//                   >
//                     {item?.label}
//                   </p>
//                 </div>
//                 {/* <img
//                   src={item?.chart}
//                   alt="chart"

//                 /> */}
//                 <Chart
//                   options={{
//                     ...options,
//                     colors: [item.color], // لون الخط يتطابق مع لون النص
//                     fill: {
//                       ...options.fill,
//                       gradient: {
//                         ...options.fill.gradient,
//                         colorStops: [
//                           [0, `${item.color}48`], // بداية التدرج (مع عتامة 48)
//                           [100, `${item.color}00`], // نهاية التدرج (مع عتامة 00)
//                         ],
//                       },
//                     },
//                   }}
//                   series={series}
//                   type="area"
//                   height={70}
//                   width={120}
//                 />
//               </div>
//             </Card>
//           </Col>
//         ))}
//       </Row>
//     </div>
//   );
// };

// export default DashboardCards;
